import $ from 'jquery';
import VueSlickCarousel from 'vue-slick-carousel'
import SingleVideo from "@/components/singleVideo/SingleVideo.vue";

export default {
    name: "VideoGallery",
    props: {
        videoGallery: { type: Array }
    },
    data () {
        return {
            gallerySettings: {
                 arrows: true,
                 dots: false,
                 infinite: false,
                 slidesToShow: 1,
                 slidesToScroll: 1,
                 adaptiveHeight: true,
                 responsive: [
                     {
                       breakpoint: 768,
                       settings: {
                         arrows: false,
                         dots: true
                       }
                     }
                 ]
             }
        }
    },
    components: {
      VueSlickCarousel,
      SingleVideo
    }

};